module.exports = __webpack_public_path__ + "962c279d09eef418c37914d449db2ee7.png";